import React from "react";
import { Form } from "semantic-ui-react";
import { useTranslation } from "ceco-polyglot";
import graphql from "babel-plugin-relay/macro";
import { createFragmentContainer } from "react-relay";

import "./dropdownCategories.scss";
const DropdownCategories = ({
  formErrors,
  handleChangeCategory,
  formData,
  allCategories: { edges },
  required,
}) => {
  const t = useTranslation();
  const categories = edges.map((category) => {
    const { node } = category;
    return {
      key: node.id,
      text: node.name,
      value: node.id,
      image: { avatar: true, src: node.picture },
    };
  });

  return (
    <Form.Dropdown
      placeholder={t("form.category")}
      label={t("form.category")}
      name="category"
      error={formErrors && formErrors["category"]}
      fluid
      search
      defaultValue={formData?.category || ""}
      noResultsMessage={t("message.noResultsCategories")}
      selection
      onChange={handleChangeCategory}
      required={required}
      options={categories}
      clearable
    />
  );
};

export default createFragmentContainer(DropdownCategories, {
  allCategories: graphql`
    fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
      edges {
        node {
          id
          name
          picture
        }
      }
    }
  `,
});
